export const categories = [
  {
    value: 'people',
    label: 'Seeking People',
  },
  {
    value: 'projects',
    label: 'Seeking Project',
  },
  {
    value: 'paid',
    label: 'Paid Gigs',
  },
  {
    value: 'mentorship',
    label: 'Mentorship',
  },
  {
    value: 'study',
    label: 'Study',
  },
  {
    value: 'misc',
    label: 'Misc',
  },
];

export const subCategories = {

  people: [
    {
      value: 'frontend',
      label: 'Seeking Frontend',
    },
    {
      value: 'backend',
      label: 'Seeking Backend',
    },
    {
      value: 'designer',
      label: 'Seeking Designer',
    },
    {
      value: 'devops',
      label: 'Seeking Devops',
    },
    {
      value: 'anyone',
      label: 'Open to Anyone',
    },
  ],

  projects: [
    {
      value: 'frontend',
      label: 'Frontend Role',
    },

    {
      value: 'backend',
      label: 'Backend Role',
    },
    {
      value: 'designer',
      label: 'Designer Role',
    },
    {
      value: 'devops',
      label: 'Devops Role',
    },
    {
      value: 'anyone',
      label: 'Any Role',
    },
  ],

  paid: 
  [    
    {
      value: 'frequent',
      label: 'Frequent Need',
    },
    {
      value: 'infrequent',
      label: 'Infrequent Need',
    },
    {
      value: 'once',
      label: 'One time',
    },
  ],

  mentorship: [
    {
      value: 'offering',
      label: 'Offering Mentorship',
    },
    {
      value: 'seeking',
      label: 'Seeking Mentorship',
    },
  ],

  study: [
    {
      value: 'technical',
      label: 'Technical Interview Prep',
    },
    {
      value: 'behavioral',
      label: 'Behavioral Interview Prep',
    },
    {
      value: 'course',
      label: 'Course Collaboration',
    },
    {
      value: 'study',
      label: 'CS study group',
    },
  ],
  misc: [
    {
      value: 'classifieds',
      label: 'Classifieds',
    },
    {
      value: 'book',
      label: 'Book Exchange',
    },
    {
      value: 'advice',
      label: 'Career Advice',
    },
    {
      value: 'questions',
      label: 'Questions',
    },
  ]
}